import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import type { Features } from 'hb-react/types';

export const useFeature = <T extends keyof Features>(feature: T) => {
  const {
    currentNetwork: { features, app_pages: appPages = [] },
  } = useDefaultAppContexts();

  const featurePages = useMemo(
    () =>
      appPages
        .flatMap((page) => {
          const subMenuFakePages =
            page?.submenus?.map((subMenu) => ({
              menu: subMenu,
            })) || [];

          return [page, ...subMenuFakePages];
        })
        .filter(Boolean),
    [appPages],
  );

  return useMemo(() => {
    const featurePage = featurePages.find(
      (page) => page?.menu?.identifier === feature,
    );

    return {
      feature: features?.[feature] || {},
      featurePage,
      appPageConfig: featurePage?.menu,
    };
  }, [features, feature, appPages]);
};
